module.exports = __webpack_public_path__ + "img/2025big5.02c1fae9.jpg";